import React, { memo } from 'react';

import SecureCheckoutRow from '../../PostJobListing/components/SecureCheckoutRow';
import { useAppSelector } from '../../../store/hooks';
import { hasFreeListingBonus } from '../../../constants/hostName';

// Header band for the bulk-packages flow — same layout as PostJobListing's
// ListingHeaderBand (title + one-line sub over a 2px rule, centered page
// container via .cpg-band) for cross-flow consistency. No draft chip / clear
// link here: the packages flow has no autosave cookie.
const ECOSYSTEM_COPY = 'Every listing runs across the entire BevNET CPG Media ecosystem, including BevNET, Brewbound, and Nosh.';
// CPG Media packs are a flat 5 listings; the other brands add a free 6th, so only
// they get the "and get 1 free" clause.
const BAND_COPY_WITH_FREE = `Buy a pack of 5 job listings and get 1 free. ${ECOSYSTEM_COPY}`;
const BAND_COPY_FLAT = `Buy a pack of 5 job listings. ${ECOSYSTEM_COPY}`;

const PackagesHeaderBand = () => {
  const siteNumber = useAppSelector(({ pathnameSettings }) => pathnameSettings.siteNumber);
  const bandCopy = hasFreeListingBonus(siteNumber) ? BAND_COPY_WITH_FREE : BAND_COPY_FLAT;

  return (
    <div className="cpg-band">
      <div className="cpg-band__left">
        <span className="cpg-band__eyebrow">For hiring several roles</span>
        <h1 className="cpg-band__title">
          Job Listing Packages
        </h1>
        <p className="cpg-band__sub">{bandCopy}</p>
        <SecureCheckoutRow />
      </div>
    </div>
  );
};

export default memo(PackagesHeaderBand);
